<template>
  <div class="su">
    <div class="su-channel" v-if="channel">
      <aside class="label">
        Channel
      </aside>
      <aside class="name" v-if="channel.name">
        {{channel.name}}
      </aside>
    </div>
    <auth
      :title="'Sign In/Up'"
      :description="'Monetize your content with no up-front cost. Get started in one click.'"
      :dark="true"
      @callback="handleCallback"
    />
  </div>
</template>

<script>
import Auth from '../_Shared/Auth'
import analytics from '../../mixins/analytics'
import { mapState } from 'vuex'

export default {
  name: 'SignUp',
  components: {
    'auth': Auth,
  },
  mixins: [
    analytics
  ],
  computed: {
    ...mapState(['channel'])
  },
  methods: {
    handleCallback () {
      this.$router.push({name: 'create'})
      this.trackAndIdentify('[Fanfolk] Sign In')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .su {
    background: $color-dark;
    color: $color-white;
    height: 100%;
    overflow: auto;
  }

  .su-channel {
    @include container;
    padding: $unit-3;
    padding-bottom: 0;

    .label {
      @include caps;
    }

    .name {
      font-size: $fontSize-medium;
      margin: $unit-1 0;
    }
  }

</style>
